module.exports = __webpack_public_path__ + "static/media/logo-symbol-white.c2727b0f.svg";